import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState, useRef, useEffect, useContext } from "react";
import { analyticsReady, dispatchImmediateAnalyticsEvent, dispatchAnalyticsEvent, setJLData, ANALYTICS_JLDATA_UPDATED, addCustomSchema } from "@JohnLewisPartnership/jl-analytics";
import { createDebugger } from "../../utils/debug";
var debug = createDebugger("analytics");
export var Context = /*#__PURE__*/ React.createContext();
export { addCustomSchema };
export var useAnalytics = function(eventName) {
    var defaultEventData = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!eventName) {
        throw new Error('Expected useAnalytics("event.name") received event name: "'.concat(eventName, '"'));
    }
    return function() {
        var eventData = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        dispatchAnalyticsEvent(eventName, _object_spread({}, defaultEventData, eventData));
    };
};
export var useImmediateAnalytics = function(eventName) {
    var defaultEventData = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!eventName) {
        throw new Error('Expected useAnalytics("event.name") received event name: "'.concat(eventName, '"'));
    }
    return function() {
        var eventData = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        dispatchImmediateAnalyticsEvent(eventName, _object_spread({}, defaultEventData, eventData));
    };
};
export var usePageLoadReady = function() {
    var ref = useContext(Context), lastUpdatedTimestamp = ref[0];
    var firedRef = useRef(false);
    useEffect(function() {
        var readyInterval = setInterval(function() {
            if (analyticsReady() && lastUpdatedTimestamp && !firedRef.current) {
                firedRef.current = true;
                clearInterval(readyInterval);
                dispatchImmediateAnalyticsEvent("pageload");
            }
        }, 100);
    }, [
        lastUpdatedTimestamp
    ]);
};
export var Provider = function(param) {
    var children = param.children;
    var ref = useState(), lastUpdatedTimestamp = ref[0], setTimestamp = ref[1];
    var updateTimestamp = function() {
        return setTimestamp(Number(new Date()));
    };
    return /*#__PURE__*/ _jsx(Context.Provider, {
        value: [
            lastUpdatedTimestamp,
            updateTimestamp
        ],
        children: children
    });
};
export var Analytics = function(payload) {
    var ref = useContext(Context), updateTimestamp = ref[1];
    useEffect(function() {
        setJLData(payload);
        updateTimestamp();
        debug('dispatching event "'.concat(ANALYTICS_JLDATA_UPDATED, '"'));
        document.body.dispatchEvent(new CustomEvent(ANALYTICS_JLDATA_UPDATED));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        payload
    ]);
    return null;
};
